<template>
  <div
    style="
      width: 100%;
      height: 100%;
      background: #fff;
      display: block;
      position: absolute;"
  >
    <div
      style="
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;"
      >
      <b-img
        :src="appLogoImage"
        alt="logo"
        style="
          width: 80%;
          max-width: 500px;
          margin: auto;
          line-height: 100%;"
      />
    </div>
  </div>
</template>

<script>
import { BCard, BCardText, BAlert, BLink, BButton, BImg } from 'bootstrap-vue';
import { $themeConfig } from '@themeConfig'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BButton,
    BAlert,
    BImg
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
      localDB: new PouchDB(localStorage.getItem('database')),
      remoteDB: new PouchDB(localStorage.getItem('url')+'/'+localStorage.getItem('database')),
    }
  },
  async created() {
    this.$swal({
      icon: 'warning',
      title: '',
      text: 'Synchronisation en cours ...',
      footer: '',
      showConfirmButton: false,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })

    await this.remoteDB.sync(this.localDB)
    .on('complete', complete => {
      this.$swal({
        icon: 'success',
        title: '',
        text: 'Synchronisation terminée ...',
        footer: '',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      }).then(result => {

        this.traitement()

      })
    })
    .on('error', err => {
      this.$swal({
        icon: 'error',
        title: 'Oops...',
        text: 'Quelque chose s\'est mal passé, vérifiez votre configuration !',
        footer: '',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
      localStorage.removeItem('user')
      localStorage.removeItem('role')
      localStorage.removeItem('setting')
      this.$router.push({ path: '/login' })
    })

  },
  methods: {
    async traitement() {

      this.$swal({
        icon: 'warning',
        title: '',
        text: 'Indexation en cours ...',
        footer: '',
        showConfirmButton: false,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })

      this.localDB.createIndex({
        index: { fields: ['id', 'type', 'commerciaux', 'commercial', 'categorie', 'fournisseur', 'codearticle', 'inactif'] },
      })
      .then( result => {
        this.$swal({
          icon: 'success',
          title: '',
          text: 'Indexation terminée ...',
          footer: '',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(result => {
          this.loadhomepage()
        })
      })
      .catch( err => {
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'Quelque chose s\'est mal passé, vérifiez votre configuration !',
          footer: '',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        localStorage.removeItem('user')
        localStorage.removeItem('role')
        localStorage.removeItem('setting')
        this.$router.push({ path: '/login' })
      })
    },
    async loadhomepage() {
      await this.findSetting()
      await this.findCommerciaux()

      await this.$router.push({ path: '/' })
    },
    findFirstImageAttachmentKey(attachments) {
      if (!attachments || typeof attachments !== 'object') return null
      for (const key of Object.keys(attachments)) {
        const meta = attachments[key]
        const ct = (meta && meta.content_type) || ''
        if (/^image\//i.test(ct)) return key
        if (/\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(key)) return key
      }
      return null
    },
    blobToDataUrl(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    async findSetting() {
      // Lecture des document sur l'index de recherhe type=setting
      const resultSet = await this.localDB.find({ selector: { type: 'setting' } })
      if (resultSet.docs.length === 0) {
        this.createSetting()
        return
      }
      const doc = resultSet.docs[0]
      const payload = { ...doc }
      const attKey = this.findFirstImageAttachmentKey(doc._attachments)
      if (attKey) {
        try {
          const blob = await this.localDB.getAttachment(doc._id, attKey)
          payload.imageBase64 = await this.blobToDataUrl(blob)
        } catch (err) {
          console.warn('Erreur lecture pièce jointe setting', err)
        }
      }
      if (payload._attachments) delete payload._attachments
      localStorage.setting = JSON.stringify(payload)
    },
    async findCommerciaux() {
      // Lecture des document sur l'index de recherhe type=commercial
      await this.localDB.find({selector: { type: 'commerciaux', id: 'org.couchdb.user:'+localStorage.getItem('user') }}).then(result => {
        if(result.docs.length === 0) {
          this.createProfile()
        }
        else {
          console.log('commercial', result.docs.length)
          localStorage.commercial = JSON.stringify(result.docs[0])
        }
      })
    },
    // Création du fichier setting au premier démarrage
    async createSetting() {
      await this.localDB.put(
        {
          "_id": uuidv4(),
          "type": "setting",
          "devise": "€",
          "typedeprix": "HT",
          "filtre_familles_par_commerciaux": true,
          "filtre_articles_par_commerciaux": true,
          "filtre_clients_par_commerciaux": true,
          "filtre_commandes_par_commerciaux": true,
          "societe": "",
          "adresse1": "",
          "adresse2": "",
          "adresse3": "",
          "codepostal": "",
          "ville": "",
          "departement": "",
          "pays": "FRANCE",
          "fraisport": 0,
          "fraisportmontant": 0,
          "franco": 0,
          "francomontant" : 0,
          "datecreation": moment().format('YYYY-MM-DDTHH:mm:ss'),
          "datemodif": moment().format('YYYY-MM-DDTHH:mm:ss'),
        }
        , (err, response) => {
        if (err) {
          console.log('errvalidation', err);
        } else {
          this.localDB.sync(this.remoteDB).on('complete', complete => {
            this.findSetting()
          })
        }
      })
    },
    // Création du fichier commercial au premier démarrage
    async createProfile() {
      await this.localDB.put(
        {
          "_id": uuidv4(),
          "type": "commerciaux",
          "id": "org.couchdb.user:"+localStorage.getItem('user'),
          "email": localStorage.getItem('user'),
          "nom": "",
          "prenom": "",
          "phone": "",
          "showprice": "false",
          "showfraisport": "true",
          "avatar": "",
          "srvsmtp": "",
          "smtpsll": "",
          "portsmtp": "",
          "loginsmtp": "",
          "datecreation": moment().format('YYYY-MM-DDTHH:mm:ss'),
          "datemodif": moment().format('YYYY-MM-DDTHH:mm:ss'),
        }
        , (err, response) => {
        if (err) {
          console.log('errvalidation', err);
        } else {
          this.localDB.sync(this.remoteDB).on('complete', complete => {
            this.findCommerciaux()
          })
        }
      })
    },
  }
}
</script>